'use strict';
module.exports = require('./OverlayPanel.vue');